import React from 'react'
import Link from 'gatsby-link'
import imgCF from './jake.jpg';
import BackNav from '../components/BackNav'
import FooterRainbow from '../components/FooterRainbow';
import Unicorn from '../components/Unicorn';

const Gusto = () =>
  <div>
    <div className="main work-page relative">
      <Unicorn />
      <h1 className='huge-text'>Coming soon</h1>
      <p className='half-page'>I will publish this page after my recent work at Gusto becomes publicly available. Until then, you'll have to use your imagination.<br /><br />Take my word for it, the work is great ;)</p>
      <p className='half-page'>If you're reading this because you're trying to recruit me, then I'm sorry to inform you that I'm not looking for new opportunities and I will be joining Amplitude in April of 2020. </p>
      <BackNav />
    </div>
    
    <FooterRainbow />
  </div>

export default Gusto



// WEBPACK FOOTER //
// ./src/pages/gusto.js